import { RoutePath } from "src/data/Routes";
import { Nav, NavContext, NavDomain } from "./NavDomain";

export const tapeDomain: NavDomain = {
  matches: clsPath => clsPath === RoutePath.TAPE,

  /** Tape always uses /tape/type/... — redirects legacy links from search/CG/tables. */
  normalize({ clsPath, allType, typeOrDevice, itemName, location }: NavContext): Nav {
    if (allType === RoutePath.TYPE || !typeOrDevice && !itemName) return null;
    const to = [
      clsPath,
      RoutePath.TYPE,
      typeOrDevice ? '/' + typeOrDevice : '',
      itemName ? '/' + itemName : '',
    ].join('') + location.search + location.hash;
    if (decodeURIComponent(location.pathname + location.search + location.hash) !== decodeURIComponent(to)) {
      return { to, options: { replace: true } };
    }
    return null;
  },
};
